import PropTypes from "prop-types";
import React from "react";
import { Button } from "cxa-components";
import { intlShape, injectIntl } from "react-intl";
import messages from "components/messagesDescription";

class UploadPhotoForm extends React.Component {
  constructor() {
    super();

    this.state = {
      uploadDisabled: true,
    };

    this.handleAddFile = this.handleAddFile.bind(this);
    this.handleUploadImage = this.handleUploadImage.bind(this);
  }

  handleAddFile() {
    if (this.image.files.length > 0) {
      this.setState({
        uploadDisabled: false,
      });
    }
  }

  handleUploadImage(event) {
    if (event) {
      event.preventDefault();
    }
    const image = this.image.files[0];
    const reader = new FileReader();

    reader.onload = function(output) {
      this.props.uploadImage({ image: output.target.result });
    }.bind(this);

    reader.readAsDataURL(image);
  }

  render() {
    const { intl, isWebcamSupported } = this.props;

    return (
      <article className="card">
        <section>
          <p>
            <label htmlFor="face-image">
              {intl.formatMessage(messages.choosePhotoDescription)}
            </label>
          </p>
          <input
            name="image"
            id="face-image"
            type="file"
            ref={image => (this.image = image)}
            onChange={this.handleAddFile}
            accept="image/*"
          />
        </section>
        <footer>
          <p>
            <Button
              disabled={this.state.uploadDisabled}
              onClick={this.handleUploadImage}
              submitting={this.props.submitting}
            >
              {intl.formatMessage(messages.uploadPhotoTextDescription)}
            </Button>
            {isWebcamSupported &&
              <Button secondary onClick={this.props.handleCancelUpload}>
                {intl.formatMessage(messages.cancelTextDescription)}
              </Button>}
            <Button secondary onClick={this.props.handleSkip}>
              {intl.formatMessage(messages.skipTextDescription)}
            </Button>
          </p>
        </footer>
      </article>
    );
  }
}

UploadPhotoForm.propTypes = {
  uploadImage: PropTypes.func,
  handleCancelUpload: PropTypes.func,
  handleSkip: PropTypes.func,
  isWebcamSupported: PropTypes.bool,
  submitting: PropTypes.bool,
  intl: intlShape.isRequired,
};

export default injectIntl(UploadPhotoForm);



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/uploadPhotoForm.jsx